export class AudioInput{
    text:string
    value:string
  }